import React, { useMemo, memo } from 'react';
import classNames from 'classnames';

import { SerializedError } from '@reduxjs/toolkit';
import WindStationCardPlaceholder from '../WindStationCardPlaceholder';

import styles from './WindStationCardPlaceholders.module.scss';

const getClass = (
  loading?: boolean,
  error?: boolean,
  noWindStationsFound?: boolean,
  rootClass?: string,
) =>
  classNames(
    'sl-wind-station-card-placeholders',
    {
      [styles.placeholders]: true,
      [styles.placeholdersLoading]: loading,
      [styles.placeholdersError]: error,
      [styles.placeholdersNoWindStations]: noWindStationsFound,
    },
    rootClass,
  );

interface Props {
  numPlaceholders?: number;
  largeOnly?: boolean;
  loading?: boolean;
  noWindStationsFound?: boolean;
  error?:
    | {
        message: string;
        status?: number | undefined;
      }
    | SerializedError
    | undefined;
  classes?: {
    root?: string;
    placeholder?: string;
  };
}

const WindStationCardPlaceholders: React.FC<Props> = ({
  numPlaceholders = 12,
  largeOnly,
  loading,
  error,
  noWindStationsFound,
  classes = {},
}) => {
  const placeholders = useMemo(
    () => [...Array(numPlaceholders)].map((_, index) => ({ id: index, isPlaceholder: true })),
    [numPlaceholders],
  );

  if (!noWindStationsFound) {
    return (
      <ul
        data-testid="WindStationCardPlaceholders"
        className={getClass(loading, !!error, noWindStationsFound, classes.root)}
      >
        {placeholders.map((placeholder) => (
          <li key={placeholder.id}>
            <WindStationCardPlaceholder
              classes={{ root: classes.placeholder }}
              largeOnly={largeOnly}
              loading={loading}
            />
          </li>
        ))}
      </ul>
    );
  }
  return null;
};

export default memo(WindStationCardPlaceholders);
